import { useEffect, useState } from "react";
import { useAccount, useBalance, useChainId, useConnect, useDisconnect } from "wagmi";

export type UseWeb3Return = {
  account: string | null;
  chainId: number | undefined;
  balance: string | undefined;
  connect: (connector?: any) => Promise<void>;
  disconnect: () => void;
  isConnected: boolean;
  connector: any;
  ethereum: any;
  error: Error | null;
  status: string;
};

/**
 * Adapter hook that provides use-wallet-like API using wagmi under the hood
 * This allows gradual migration from use-wallet to wagmi
 */
export function useWeb3(): UseWeb3Return {
  const { address, isConnected, connector } = useAccount();
  const chainId = useChainId();
  const { connect: wagmiConnect, connectors, error: connectError } = useConnect();
  const { disconnect: wagmiDisconnect } = useDisconnect();
  const { data: balanceData } = useBalance({
    address: address,
  });

  const [ethereum, setEthereum] = useState<any>(null);

  useEffect(() => {
    // Get the ethereum provider from globalThis
    if (typeof globalThis !== "undefined" && (globalThis as any).ethereum) {
      setEthereum((globalThis as any).ethereum);
    }
  }, []);

  const connect = async (connectorArg?: any) => {
    try {
      const connectorToUse = connectorArg || connectors[0];
      if (connectorToUse) {
        await wagmiConnect({ connector: connectorToUse });
      }
    } catch (err) {
      console.error("Failed to connect:", err);
    }
  };

  const disconnect = () => {
    wagmiDisconnect();
  };

  return {
    account: address || null,
    chainId: chainId,
    balance: balanceData?.formatted,
    connect,
    disconnect,
    isConnected,
    connector,
    ethereum,
    error: connectError,
    status: isConnected ? "connected" : "disconnected",
  };
}

export default useWeb3;
